"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyMenuBanner = exports.toolbar_builder = exports.setDiagram = exports.addAllDropDownFlux = exports.addAllDropDownNode = exports.addSimpleLevelDropDown = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_multi_select_component_1 = require("react-multi-select-component");
const SankeyConvert_1 = require("./SankeyConvert");
const SankeyUtils_1 = require("./SankeyUtils");
const d3 = __importStar(require("d3"));
// import { FaNotesMedical } from 'react-icons/fa'
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const addSimpleLevelDropDown = (t, data, set_data) => {
    const { nodeTags } = data;
    if (Object.keys(nodeTags['Primaire'].tags).length < 2) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const tmp = Object.entries(nodeTags['Primaire'].tags).filter(tag => tag[1].selected);
    const selected = tmp.length > 0 ? tmp[0][0] : '';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("td", null, react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, key: nodeTags['Primaire'].group_name, value: selected, placeholder: 'all', onChange: (evt) => { handleSimpleDropdown(evt, nodeTags['Primaire'], data, set_data); } }, Object.entries(nodeTags['Primaire'].tags).map(([tag_key, tag], i) => {
                return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
            }))))));
    // return (<><tr><th >{t('Banner.ndd_lst')}</th></tr>{allDD}</>)
};
exports.addSimpleLevelDropDown = addSimpleLevelDropDown;
const addAllDropDownNode = (t, data, set_data, level) => {
    const color = 'black';
    const { nodeTags } = data;
    let banner_grouptag = Object.entries(nodeTags).filter(([, tags_group]) => tags_group.banner !== 'none' && tags_group.banner !== 'level');
    if (level) {
        const nb_level_tag = Object.values(nodeTags).filter(tags_group => tags_group.banner === 'level' && (Object.keys(tags_group.tags).length > 0)).length;
        if (nb_level_tag > 1) {
            banner_grouptag = Object.entries(nodeTags).filter(([, tags_group]) => tags_group.banner === 'level' && tags_group.group_name !== 'Primaire' && Object.keys(tags_group.tags).length > 0);
        }
        else {
            banner_grouptag = Object.entries(nodeTags).filter(([, tags_group]) => tags_group.banner === 'level' && Object.keys(tags_group.tags).length > 1);
        }
    }
    const allDD = banner_grouptag.map(([, tags_group]) => {
        const tags_selected = Object.entries(data['nodeTags']).filter((k) => { return k[1] == tags_group; })[0];
        if (tags_group.banner == 'one') {
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: color } }, tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.5', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.5' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, key: tags_group.group_name, placeholder: 'all', onChange: (evt) => {
                                handleSimpleDropdown(evt, tags_group, data, set_data);
                            } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                            return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                        })))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.5', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.5' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data.links).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = 'no_colormap';
                                        });
                                        data.colorMap = tags_selected[0];
                                        data['nodeTags'][tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
        else if (tags_group.banner === 'level' && Object.values(tags_group.tags).length > 0) {
            if (Object.keys(tags_group.tags).length < 1) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            const tmp = Object.entries(tags_group.tags).filter(tag => tag[1].selected);
            const selected = tmp.length > 0 ? tmp[0][0] : '';
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null, banner_grouptag.length > 1 ? react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: color } }, tags_group.group_name) : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.4', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.4' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, key: tags_group.group_name, value: selected, placeholder: 'all', onChange: (evt) => {
                                    handleSimpleDropdown(evt, tags_group, data, set_data);
                                } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                                return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                            })))),
                    tags_group.siblings !== undefined && tags_group.siblings.length > 0 ?
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.4', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.4' },
                                    t('Banner.ndd_chk'),
                                    " ") },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: tags_group.activated, onChange: evt => {
                                        tags_group.activated = evt.target.checked;
                                        tags_group.siblings.forEach(sibling => data.nodeTags[sibling].activated = false);
                                        SankeyUtils_1.set_nodes_level(data);
                                        set_data(Object.assign({}, data));
                                    } }))) : react_1.default.createElement(react_1.default.Fragment, null))));
        }
        else if (tags_group.banner == 'multi') {
            const options = Object.entries(tags_group.tags).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            const selected = Object.entries(tags_group.tags).filter(d => d[1].selected).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: color } }, tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.3', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.3' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_filter_node_link', style: { widthMax: '200px', color: 'black' }, valueRenderer: (selected) => {
                                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun tag sélectionné';
                                }, labelledBy: 'dropdown_node_filter', overrideStrings: {
                                    'selectAll': 'Tout sélectionner',
                                }, 
                                // hasSelectAll={false}
                                value: selected, options: options, onChange: (selected) => {
                                    handleMultiDropdown(selected, tags_group, data, set_data);
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.3', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.3' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data.links).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = 'no_colormap';
                                        });
                                        data.colorMap = tags_selected[0];
                                        data['nodeTags'][tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
    });
    // if (!level) {
    //   return (<><tr><th >{t('Banner.ndd_lst')}</th><th>{t('Banner.ndd_chk')}</th></tr>{allDD}</>)
    // } else {
    //   return (<><tr><th >{t('Banner.ndd_lst')}</th><th></th></tr>{allDD}</>)
    // }
    return (react_1.default.createElement(react_1.default.Fragment, null, allDD));
};
exports.addAllDropDownNode = addAllDropDownNode;
/**
 *
 *
 * @param {React.ChangeEvent<HTMLSelectElement>} evt
 * @param {TagsGroup} tags_group
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => void}
 */
const handleSimpleDropdown = (evt, tags_group, data, set_data) => {
    const val = evt.target.value;
    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = val === tag[0]);
    if (tags_group.banner === 'level') {
        SankeyUtils_1.set_nodes_level(data);
    }
    set_data(Object.assign({}, data));
};
/**
 *
 *
 * @param {[{ label: string, value: string }]} selected
 * @param {TagsGroup} tags_group
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => void}
 */
const handleMultiDropdown = (selected, tags_group, data, set_data) => {
    const tab_sel = selected.map((d) => {
        return d.value;
    });
    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = tab_sel.includes(tag[1].name));
    // Permet d'eviter de désélectionner tous les dataTags ce qui créerait une erreur
    if (tab_sel.length == 0 && Object.values(data.dataTags).map(dt => dt.group_name).includes(tags_group.group_name)) {
        Object.entries(tags_group.tags)[0][1].selected = true;
    }
    set_data(Object.assign({}, data));
};
/**
 * Function that generate dropdown for each groupTag of linkTags
 *
 * @param {TagsCatalog} fluxTags
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => any}
 */
const addAllDropDownFlux = (t, fluxTags, data, set_data) => {
    const banner_grouptag = Object.values(fluxTags).filter(tags_group => { return (tags_group.banner == 'one' || tags_group.banner == 'multi'); });
    const allDD = banner_grouptag.map(tags_group => {
        const the_tags_group = tags_group;
        const tags_selected = Object.entries(data['fluxTags']).filter((k) => { return k[1] == the_tags_group; })[0];
        if (the_tags_group.banner == 'one') {
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, the_tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.1', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.1' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, react_1.default.createElement(react_bootstrap_1.Form.Select, { key: the_tags_group.group_name, placeholder: 'all', onChange: (evt) => {
                                handleSimpleDropdown(evt, the_tags_group, data, set_data);
                            } }, Object.entries(the_tags_group.tags).map(([tag_key, tag], i) => {
                            return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                        })))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.1', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.1' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data.links).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        data.colorMap = tags_selected[0];
                                        data.fluxTags[tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
        else if (the_tags_group.banner == 'multi') {
            const options = Object.entries(the_tags_group.tags).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            const selected = Object.entries(the_tags_group.tags).filter(d => d[1].selected).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, the_tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.2', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.2' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_filter_node_link', style: { color: 'black', width: '200px' }, valueRenderer: (selected) => {
                                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun tag sélectionné';
                                }, labelledBy: 'dropdown_node_filter', overrideStrings: {
                                    'selectAll': 'Tout sélectionner',
                                }, 
                                // hasSelectAll={false}
                                value: selected, options: options, onChange: (selected) => {
                                    handleMultiDropdown(selected, the_tags_group, data, set_data);
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.2', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.2' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data['links']).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        data.colorMap = tags_selected[0];
                                        data['fluxTags'][tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("th", null, t('Banner.ndd_lst')),
            react_1.default.createElement("th", null, t('Banner.ndd_chk'))),
        allDD.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); })));
};
exports.addAllDropDownFlux = addAllDropDownFlux;
const setDiagram = (the_diagram, data, set_data) => {
    //const the_diagram = evt.target.value as string
    const sous_filieres = window.sankey.sous_filieres;
    const new_data = JSON.parse(JSON.stringify(window.sankey[sous_filieres[the_diagram]]));
    //Object.assign(sankey_data, new_data)
    SankeyConvert_1.convert_data(new_data);
    new_data.static_sankey = true;
    // if (!is_split) {
    //   set_diagram(the_diagram)
    // }
    Object.values(data.nodes).forEach(node => {
        node.node_visible = true;
        node.display = true;
    });
    SankeyUtils_1.set_nodes_level(data);
    // new_data.fit_screen = true
    d3.select(' .opensankey #svg').on('.zoom', null);
    set_data(Object.assign({}, new_data));
};
exports.setDiagram = setDiagram;
const toolbar_builder = (t, data, set_data, mode_selection, user_scale, set_user_scale, filter, set_current_filter, detail_level, url_prefix, first_selected_node, set_first_selected_node, min_width_and_height, setDiagram, set_show_modal_welcome) => {
    const opacity_advanced = !window.SankeyToolsStatic ? '0.3' : '0';
    const level_filter = Object.entries(data.nodeTags).filter(([, v]) => v.banner === 'level').length > 0;
    const node_filter = Object.entries(data.nodeTags).filter(([, v]) => v.banner !== 'none' && v.banner !== 'level').length > 0;
    const flux_filter = Object.entries(data.fluxTags).filter(([, v]) => v.banner !== 'none').length > 0;
    /**
     * Change the mouse behavior
     *
     * @param {string} val
     */
    const setSelectionMode = (val) => {
        mode_selection.current = val;
        //- trigger update
        const tutu = filter;
        set_current_filter(filter + 1);
        set_current_filter(tutu);
        d3.selectAll(' .opensankey #svg #path-flux').remove();
        if (val == 's' && (Object.values(data.nodes).filter(d => d.name == 'node_tmp').length > 0 || Object.keys(first_selected_node).length != 0)) {
            data.nodes = Object.fromEntries(Object.entries(data.nodes).filter(n => n[1].name != 'node_tmp'));
            set_first_selected_node({});
        }
        // set_mode_selection(val)
    };
    let sous_filieres = undefined;
    if (window.sankey && window.sankey.sous_filieres) {
        sous_filieres = window.sankey.sous_filieres;
    }
    let is_split = false;
    const diagrams = {};
    if (sous_filieres) {
        is_split = Object.keys(sous_filieres)[0].includes('/');
        if (is_split) {
            Object.keys(sous_filieres).forEach(s => {
                const path = s.split('/');
                if (!(path[0] in diagrams)) {
                    diagrams[path[0]] = [path[1]];
                }
                else {
                    diagrams[path[0]].push(path[1]);
                }
            });
        }
        else {
            Object.keys(sous_filieres).forEach(s => diagrams[s] = [s]);
        }
    }
    const [diagram, set_diagram] = react_1.useState(Object.keys(diagrams).length > 0 ? Object.keys(diagrams)[0] : '');
    const [diagram2, set_diagram2] = react_1.useState(Object.keys(diagrams).length > 0 ? Object.values(diagrams)[0][0] : '');
    const diagram_label = 'Diagrammes';
    let max_link_value = 0;
    Object.values(data.links).forEach(link => {
        const new_max_link_value = SankeyUtils_1.findMaxLinkValue(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    // Create the differents popover of tag filter  and link value filter
    //Popover element to handle filter on links, it contians :
    // - scale of link
    // - filter on link (if value of link is inferior to filter then the link is not displayed)
    // - filter on link label
    // - filter on null link (if link value is null (0), we can display it or not)
    const link_filter = react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-link-filter", style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.ff')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, { style: { width: '600px' } },
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.Echelle'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: user_scale, onChange: evt => {
                                set_user_scale(+evt.target.value);
                            }, onBlur: () => {
                                data.user_scale = user_scale;
                                set_data(Object.assign({}, data));
                            } }),
                        react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, null),
                        react_1.default.createElement(react_bootstrap_1.Form.Text, null,
                            "    (",
                            t('MEP.vp100'),
                            ")"))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Banner.filtre'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: max_link_value, value: filter, onChange: evt => set_current_filter(Number(evt.target.value)) })),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', type: 'number', min: 0, max: filter, value: filter, onChange: (evt) => {
                                let tmp = +evt.target.value;
                                if (tmp > max_link_value) {
                                    tmp = max_link_value;
                                }
                                set_current_filter(tmp);
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Banner.fl'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: max_link_value, value: data.display_style.filter_label, onChange: evt => {
                                data.display_style.filter_label = +evt.target.value;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', type: 'number', min: 0, max: max_link_value, value: data.display_style.filter_label, onChange: (evt) => {
                                let tmp = +evt.target.value;
                                if (tmp > max_link_value) {
                                    tmp = max_link_value;
                                }
                                data.display_style.filter_label = tmp;
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                            t('Banner.fn'),
                            ":")),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('Banner.visible'), onChange: evt => {
                                data.display_style.null_flux = evt.target.checked;
                                set_data(Object.assign({}, data));
                            } }))))));
    const DT_length = Object.keys(data.dataTags).length;
    // Recursive function to create multiple copy of a link,according to the number of dataTags selected, to display the different value of a same link
    const recursionDataTag = (DT, ind, suffix, link_to_copy, new_links) => {
        const DT_l = Object.values(DT).length;
        Object.values(Object.values(DT)[ind].tags)
            .filter(t => t.selected).forEach((d, i) => {
            const n_suffix = suffix + '_' + i;
            // Depth search of group_dataTag, if it the deepest, a link is created with a specific id to retrieve the right value of the link in getLinkValue
            // (Deepest= last group_dataTag )
            if (ind == DT_l - 1) {
                const n_l = JSON.parse(JSON.stringify(link_to_copy));
                n_l.idLink = n_l.idLink + n_suffix;
                new_links[n_l.idLink] = n_l;
                //Ajoute dans les noeuds source/target les id de flux
                const ind_in_src = data.nodes[link_to_copy.idSource].outputLinksId.indexOf(link_to_copy.idLink);
                if (ind_in_src >= 0) {
                    data.nodes[link_to_copy.idSource].outputLinksId.splice(ind_in_src, 1);
                }
                const ind_in_trgt = data.nodes[link_to_copy.idTarget].inputLinksId.indexOf(link_to_copy.idLink);
                if (ind_in_trgt >= 0) {
                    data.nodes[link_to_copy.idTarget].inputLinksId.splice(ind_in_trgt, 1);
                }
                data.nodes[link_to_copy.idSource].outputLinksId.push(n_l.idLink);
                data.nodes[link_to_copy.idTarget].inputLinksId.push(n_l.idLink);
            }
            else {
                recursionDataTag(DT, ind + 1, n_suffix, link_to_copy, new_links);
            }
        });
    };
    // Function that return a simple or multiple dropdown of groupTag of data and links
    // This allow us to choose wich grouptag to select and wich tag of these group to display
    const addAllDropDownLinks = () => {
        const banner_grouptag = Object.entries(data.dataTags).filter(([, tags_group]) => { return (tags_group.banner == 'one' || tags_group.banner == 'multi'); });
        const allDD = banner_grouptag.map(([, tags_group]) => {
            if (tags_group.banner == 'one') {
                let selected = '';
                if (Object.entries(tags_group.tags).filter(([, v]) => v.selected).length > 0) {
                    selected = Object.entries(tags_group.tags).filter(([, v]) => v.selected)[0][0];
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, tags_group.group_name),
                    react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, react_1.default.createElement(react_bootstrap_1.Form.Select, { key: tags_group.group_name, placeholder: 'all', value: selected, onChange: (evt) => {
                                const pl = Object.entries(data.links).map(l => {
                                    const suffixeStart = l[0].indexOf('_');
                                    if (suffixeStart >= 0) {
                                        l[0] = l[0].slice(0, suffixeStart);
                                        l[1].idLink = l[0];
                                        data.nodes[l[1].idSource].outputLinksId = data.nodes[l[1].idSource].outputLinksId.filter(nl => nl.indexOf('_') == -1);
                                        data.nodes[l[1].idTarget].inputLinksId = data.nodes[l[1].idTarget].inputLinksId.filter(nl => nl.indexOf('_') == -1);
                                        //Ajoute dans les noeuds source/target les id de flux
                                        const ind_in_src = data.nodes[l[1].idSource].outputLinksId.indexOf(l[1].idLink);
                                        if (ind_in_src == -1) {
                                            data.nodes[l[1].idSource].outputLinksId.push(l[0]);
                                        }
                                        const ind_in_trgt = data.nodes[l[1].idTarget].inputLinksId.indexOf(l[1].idLink);
                                        if (ind_in_trgt == -1) {
                                            data.nodes[l[1].idTarget].inputLinksId.push(l[0]);
                                        }
                                    }
                                    return l;
                                });
                                // Reforme les flux originel (sans suffixe) et supprime les doublons par la méme occasions
                                const pureLinks = Object.fromEntries(pl);
                                data.links = pureLinks;
                                handleSimpleDropdown(evt, tags_group, data, set_data);
                            } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                            return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                        }))))));
            }
            else if (tags_group.banner == 'multi') {
                const selected = Object.entries(tags_group.tags).filter(d => d[1].selected).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
                const options = Object.entries(tags_group.tags).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name, 'disabled': ((selected.length < 2 && tag[1].name == selected[0].label)) }; });
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, tags_group.group_name),
                    react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_filter_node_link', style: { color: 'black', width: '200px' }, labelledBy: 'dropdown_link_filter', overrideStrings: {
                            'selectAll': 'Tout sélectionner',
                        }, value: selected, options: options, onChange: (selected) => {
                            handleMultiDropdown(selected, tags_group, data, set_data);
                            //Multiplie les flux par le nombre de dataTags Sélectionné ( et si le lien à une valeur pour ce dataTags)
                            if (Object.keys(data.dataTags).length > 0) {
                                const pl = Object.entries(data.links).map(l => {
                                    const suffixeStart = l[0].indexOf('_');
                                    if (suffixeStart >= 0) {
                                        l[0] = l[0].slice(0, suffixeStart);
                                        l[1].idLink = l[0];
                                        data.nodes[l[1].idSource].outputLinksId = data.nodes[l[1].idSource].outputLinksId.filter(nl => nl.indexOf('_') == -1);
                                        data.nodes[l[1].idTarget].inputLinksId = data.nodes[l[1].idTarget].inputLinksId.filter(nl => nl.indexOf('_') == -1);
                                    }
                                    return l;
                                });
                                // Reforme les flux originel (sans suffixe) et supprime les doublons par la méme occasions
                                const pureLinks = Object.fromEntries(pl);
                                const new_links = {};
                                Object.values(pureLinks).forEach(l => {
                                    const suffix = '';
                                    recursionDataTag(data.dataTags, 0, suffix, l, new_links);
                                });
                                data.links = new_links;
                                set_data(Object.assign({}, data));
                            }
                        } })));
            }
        });
        return allDD;
    };
    let diagrams_element = react_1.default.createElement(react_1.default.Fragment, { key: '1' });
    if (window.SankeyToolsStatic && sous_filieres && !is_split) {
        diagrams_element =
            react_1.default.createElement(react_bootstrap_1.Popover, { id: 'popover-diagram', style: { maxWidth: '100%' } },
                react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, diagram_label),
                react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '1', as: react_bootstrap_1.Col, style: { marginLeft: '10px' }, lg: "auto" },
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, onChange: evt => {
                                set_diagram(evt.target.value);
                                setDiagram(evt.target.value, data, set_data);
                            }, value: diagram }, Object.keys(sous_filieres).map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))))));
    }
    if (window.SankeyToolsStatic && sous_filieres && is_split) {
        diagrams_element =
            react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '2', as: react_bootstrap_1.Col, style: { marginLeft: '10px' }, lg: "auto" },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { className: "text-center", style: { justifyContent: 'center' } },
                    react_1.default.createElement("b", null, diagram_label)),
                react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, onChange: (evt) => {
                        set_diagram(evt.target.value);
                        const diagram_path = evt.target.value + '/' + diagrams[evt.target.value][0];
                        setDiagram(diagram_path, data, set_data);
                    }, value: diagram }, Object.keys(diagrams).map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))),
                is_split ?
                    (react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, onChange: (evt) => {
                            set_diagram2(evt.target.value);
                            const diagram_path = diagram + '/' + evt.target.value;
                            setDiagram(diagram_path, data, set_data);
                        }, value: diagram2 }, diagrams[diagram] ? (Object.values(diagrams[diagram]).map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))) : (react_1.default.createElement(react_1.default.Fragment, null)))) : (react_1.default.createElement(react_1.default.Fragment, null)));
    }
    const excel_element = window.sankey && window.sankey.excel ? (react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '3', as: react_bootstrap_1.Col, lg: "auto", style: { marginRight: '10px' } },
        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'link', href: window.sankey.excel }, t('Banner.tl')))) : (react_1.default.createElement(react_1.default.Fragment, { key: '3' }));
    const struc_data_reconciled = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'popover-details-level', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.sdr')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, placeholder: 'all', value: data.show_structure, onChange: (evt) => {
                            data.show_structure = evt.target.value;
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement("option", { key: 'structure', value: 'structure' }, "Structure"),
                        react_1.default.createElement("option", { key: 'data', value: 'data' }, "Donn\u00E9es collect\u00E9es"),
                        react_1.default.createElement("option", { key: 'reconciled', value: 'reconciled' }, "Donn\u00E9es r\u00E9concili\u00E9es"),
                        react_1.default.createElement("option", { key: 'free_interval', value: 'free_interval' }, "Donn\u00E9es r\u00E9concili\u00E9es+flux ind\u00E9termin\u00E9es (intervalles)"),
                        react_1.default.createElement("option", { key: 'free_value', value: 'free_value' }, "Donn\u00E9es r\u00E9concili\u00E9es+flux ind\u00E9termin\u00E9es (valeurs)"))))));
    //Popover element to handle node tags
    // Its a list of dropdown for each groupNodeTag where we can choose wiche group to apply and wiche tag from these group to display when selected
    const filter_color_node = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'tooltip-link-color-filter', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.fdn')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, { style: { marginLeft: '5px', width: '450px' } },
            react_1.default.createElement("table", null, (Object.entries(data.nodeTags).filter(([, v]) => v.banner !== 'none').length > 0) ? (react_1.default.createElement(react_1.default.Fragment, null, exports.addAllDropDownNode(t, data, set_data, false))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Pas de filtrage", style: { opacity: opacity_advanced, color: '#6c757d' }, disabled: true }))))));
    //Popover element to handle the display of link tags
    const filter_color_link = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'tooltip-node-color-filter', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.fdf')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, { style: { marginLeft: '5px', width: '450px' } }, exports.addAllDropDownFlux(t, data.fluxTags, data, set_data)));
    //Popover element to handle the display of data tags
    const filter_data = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'tooltip-data-color-filter', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.sdd')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, addAllDropDownLinks()),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'switch', style: { marginLeft: '-2em' }, checked: (DT_length > 0) ? (Object.values(data.dataTags).slice(DT_length - 1, DT_length)[0].show_legend) : false, onChange: evt => {
                            //Déselecitonne tous les type de tag
                            Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                            Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                            Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                            Object.values(data.nodes).forEach(el => {
                                el.colorParameter = 'local';
                                el.colorTag = 'no_colormap';
                            });
                            Object.values(data.links).forEach(el => {
                                el.colorParameter = 'local';
                                el.colorTag = 'no_colormap';
                            });
                            data.colorMap = 'no_colormap';
                            //Met le dernier dataTag en tant que couleur a suivre pour les flux
                            if (evt.target.checked) {
                                Object.values(data.nodes).forEach(el => {
                                    el.colorParameter = 'groupTag';
                                    el.colorTag = 'no_colormap';
                                });
                                Object.values(data.links).forEach(el => {
                                    el.colorParameter = 'groupTag';
                                    el.colorTag = 'no_colormap';
                                });
                                data.colorMap = 'dataTags_' + Object.keys(data.dataTags).slice(DT_length - 1, DT_length)[0];
                                Object.values(data.dataTags).slice(DT_length - 1, DT_length)[0].show_legend = evt.target.checked;
                            }
                            set_data(Object.assign({}, data));
                        } })))));
    const ui = [];
    if ((Object.keys(diagrams).length > 0)) {
        ui.push(react_1.default.createElement(react_bootstrap_1.Col, null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-diagrams', placement: 'left', trigger: 'click', rootClose: true, overlay: diagrams_element },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'dark', id: 'button-diagrams' }, 'Diagramme: ' + diagram))));
    }
    if (window.sankey && window.sankey.excel) {
        ui.push(excel_element);
    }
    let mouse_mode_edition = react_1.default.createElement(react_1.default.Fragment, null);
    // Add button for the edition of the sankey
    if (!window.SankeyToolsStatic) {
        mouse_mode_edition =
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { as: react_bootstrap_1.Col, lg: 'auto' },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-selection', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-selection' },
                        t('Banner.tooltipSelection'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: (!(mode_selection.current == 's')) ? 'outline-info' : 'info', onClick: () => { setSelectionMode('s'); } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowPointer }))),
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-liaison', placement: 'right', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-liason' },
                        t('Banner.tooltipLiason'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: (!(mode_selection.current == 'ln')) ? 'outline-secondary' : 'secondary', onClick: () => { setSelectionMode('ln'); } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faShareNodes }))));
    }
    const item_dropdown_filter = react_1.default.createElement(react_1.default.Fragment, null,
        (node_filter) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-link-color-filter', placement: 'left', trigger: 'click', rootClose: true, overlay: filter_color_node },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, null, t('Menu.Noeuds')))
            :
                react_1.default.createElement(react_1.default.Fragment, null),
        (flux_filter) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-node-color-filter', placement: 'left', trigger: 'click', rootClose: true, overlay: filter_color_link },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, null, t('Menu.flux')))
            :
                react_1.default.createElement(react_1.default.Fragment, null),
        (Object.values(data.dataTags).length > 0) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-data-filter', placement: 'left', trigger: 'click', rootClose: true, overlay: filter_data },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, null,
                    react_1.default.createElement(react_1.default.Fragment, null, t('Banner.data'))))
            :
                react_1.default.createElement(react_1.default.Fragment, null));
    ui.push(react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Col, lg: 'auto' },
        mouse_mode_edition,
        (node_filter || flux_filter || (Object.values(data.dataTags).length > 0)) ?
            react_1.default.createElement(react_bootstrap_1.DropdownButton, { autoClose: false, as: react_bootstrap_1.ButtonGroup, lg: 'auto', title: t('Banner.filter') }, item_dropdown_filter)
            : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(react_bootstrap_1.ButtonGroup, { as: react_bootstrap_1.Col, lg: 'auto' },
            (level_filter) ? react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-details-level', placement: 'left', trigger: 'click', rootClose: true, overlay: detail_level },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'warning', id: 'button-details-level' },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFolderTree })))
                :
                    react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-link-filter', placement: 'left', trigger: 'click', rootClose: true, overlay: link_filter },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'danger', id: 'button-filter-link' },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFilter }))),
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-adjust-h', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-adjust-h' },
                    t('Banner.tooltipAdjust'),
                    " ") },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'dark', onClick: () => { SankeyUtils_1.adjust_sankey_zone(data, min_width_and_height); } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowsLeftRight }))),
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-adjust-v', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-adjust-v' },
                    t('Banner.tooltipAdjust'),
                    " ") },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'dark', onClick: () => { SankeyUtils_1.adjust_sankey_zone(data, min_width_and_height, false, true); } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowsUpDown }))),
            url_prefix !== '' ?
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-structur', placement: 'left', trigger: 'click', rootClose: true, overlay: struc_data_reconciled },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'success' },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDiagramProject })))
                :
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-structur', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-structur' },
                            t('Banner.tooltipStructure'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: (data.show_structure ? 'outline-success' : 'success'), onClick: () => {
                                data.show_structure = data.show_structure == 'reconciled' ? 'structure' : 'reconciled';
                                //data.show_data = false
                                set_data(Object.assign({}, data));
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCodeBranch }))),
            window.SankeyToolsStatic ? react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-help', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-help' }, t('Banner.tooltipHelp')) },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', onClick: () => { set_show_modal_welcome(true); } }, "?")) : react_1.default.createElement(react_1.default.Fragment, null))));
    return ui;
};
exports.toolbar_builder = toolbar_builder;
/**
 * Variable containing the edition row that handle filter and the mouse behavior on the sankey draw zone
 *
 * @param {{ data: any; set_data: any; mode_visualisation: any; set_current_filter: any; url_prefix: any; }}
 * @returns
 */
const OpenSankeyMenuBanner = (t, data, set_data, toolbar) => {
    // Compute height of edition element to shift the sankey draw zone below
    //const elementNavBar=document.getElementsByClassName('bg-light')[0]
    // const elementHerowrap=document.getElementsByClassName('herowrap')[0]
    // const height_Herowrap=(elementHerowrap)?elementHerowrap.getBoundingClientRect().height:0
    //const height_navbar=(elementNavBar)?elementNavBar.getBoundingClientRect().height:0
    // if ( window.SankeyToolsStatic) {
    //   height_navbarAndHerowrap = 0
    // }
    const ui = {
        'toolbar': react_1.default.createElement(react_1.default.Fragment, null, toolbar.map((c, i) => {
            return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
        }))
    };
    return ui;
};
exports.OpenSankeyMenuBanner = OpenSankeyMenuBanner;
